import { render } from "./UserPanel.vue?vue&type=template&id=4d2b2b7c"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__